module.exports = __webpack_public_path__ + "img/alert-info.f4dde217.svg";